import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PostalCodeRegex } from '../../enum/postal-code-regex.enum';
import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import  {map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

@Injectable({
  providedIn: 'root'
})
export class CustomValidationService {
  public self;
  public supplierApiUrl = environment.runtime.userManagementApiUrl;

  constructor(private httpClient: HttpClient) {
    this.self = this;
   }

   /**
   *
   * @param control to be validated
   * @return postalCode error if value is INVALID
   */
  validatePostalCode(control: AbstractControl): ValidationErrors | null {
    if (!control.value || !control.parent) {
      return null;
    }
    const countryCode = control.parent.get('countryCode').value;
    const regex = new RegExp(PostalCodeRegex[countryCode]);

    if (!regex.test(control.value.toString())) {
      return { postalCode: true };
    }

    return null;
  }

  public validateUniqueEmail(control: AbstractControl): Observable<any> {
    if (!control.value) {
      return Observable.of(null);
    }
    return this.httpClient.get(`${this.supplierApiUrl}/supplier-mass/unique-email/${control.value}`, {}).pipe(
      map(result => {
        return !result['unique_email'] ? { duplicateEmail: true } : null;
      })
    );
  }
}
